/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { UiRadioOption } from "./ui_radio_option";
import { UiRadioStyle_Enum, uiRadioStyle_EnumFromJSON, uiRadioStyle_EnumToJSON } from "./ui_radio_style";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UiRadioGroup {
  id: string;
  label: string;
  detail: string;
  options: UiRadioOption[];
  selectedOption: number;
  style: UiRadioStyle_Enum;
}

function createBaseUiRadioGroup(): UiRadioGroup {
  return { id: "", label: "", detail: "", options: [], selectedOption: 0, style: 0 };
}

export const UiRadioGroup = {
  encode(message: UiRadioGroup, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.label !== "") {
      writer.uint32(18).string(message.label);
    }
    if (message.detail !== "") {
      writer.uint32(26).string(message.detail);
    }
    for (const v of message.options) {
      UiRadioOption.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.selectedOption !== 0) {
      writer.uint32(40).sint32(message.selectedOption);
    }
    if (message.style !== 0) {
      writer.uint32(48).int32(message.style);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UiRadioGroup {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiRadioGroup();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.label = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.detail = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.options.push(UiRadioOption.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.selectedOption = reader.sint32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.style = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UiRadioGroup {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      detail: isSet(object.detail) ? globalThis.String(object.detail) : "",
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => UiRadioOption.fromJSON(e))
        : [],
      selectedOption: isSet(object.selectedOption) ? globalThis.Number(object.selectedOption) : 0,
      style: isSet(object.style) ? uiRadioStyle_EnumFromJSON(object.style) : 0,
    };
  },

  toJSON(message: UiRadioGroup): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.detail !== "") {
      obj.detail = message.detail;
    }
    if (message.options?.length) {
      obj.options = message.options.map((e) => UiRadioOption.toJSON(e));
    }
    if (message.selectedOption !== 0) {
      obj.selectedOption = Math.round(message.selectedOption);
    }
    if (message.style !== 0) {
      obj.style = uiRadioStyle_EnumToJSON(message.style);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UiRadioGroup>, I>>(base?: I): UiRadioGroup {
    return UiRadioGroup.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiRadioGroup>, I>>(object: I): UiRadioGroup {
    const message = createBaseUiRadioGroup();
    message.id = object.id ?? "";
    message.label = object.label ?? "";
    message.detail = object.detail ?? "";
    message.options = object.options?.map((e) => UiRadioOption.fromPartial(e)) || [];
    message.selectedOption = object.selectedOption ?? 0;
    message.style = object.style ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
